import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_DEVICE_DETAILS } from './url-constants';

type StarfishDeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const StarfishDeviceDetailsEndpointSpecification: StarfishDeviceDetailsEndpointSpecification = {
    url: STARFISH_DEVICE_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'StarfishDeviceDetailsRequestParams',
    requestBodySchemaName: 'StarfishDeviceDetailsRequestBody',
    okResponseSchemaName: 'StarfishDeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:1,
};

export const invokeStarfishDeviceDetails = Helpers.makeApiRequestFn<
    Types.StarfishDeviceDetailsRequestParams,
    Types.StarfishDeviceDetailsRequestBody,
    Types.StarfishDeviceDetailsOkResponse
>(StarfishDeviceDetailsEndpointSpecification);
